import { render, staticRenderFns } from "./EiIncome.vue?vue&type=template&id=d4069ab0&"
import script from "./EiIncome.vue?vue&type=script&lang=js&"
export * from "./EiIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EiIncome.vue"
export default component.exports